import Vue from "vue";
import moment from "moment";
import axios from "axios";
import VueCountryCode from "vue-country-code";
import * as utils from "../../utils";

Vue.use(VueCountryCode);

export default {
  name: "EbillRegistration",
  components: {},
  data: function () {
    return {
      refNumberResources: { description: null, image: null },
      submitButtonDisabled: false,
      consentAll: true,
      applicantName: "",
      registerPhoneTab: false,
      registerPhoneTabError: null,
      otpVerificationPhoneTab: false,
      otpVerificationPhoneTabError: null,
      otpVerificationEmailTab: false,
      otpVerificationEmailTabError: null,
      invoiceReferenceNumberTab: false,
      invoiceReferenceNumberTabError: null,
      confirmPropertyTab: false,
      confirmPropertyTabError: null,
      subscriptionPreferenceTab: false,
      subscriptionPreferenceTabError: null,

      phoneNumber: "", //'97663322',
      email: "", //"theodoros@edams.com",
      phoneOtpCode: "",
      emailOtpCode: "",
      isPhoneOtpCodeValid: false,
      isEmailOtpCodeValid: false,
      dialCode: "",
      sessionId: -1,
      activeTab: "registerPhone",
      //activeTab: 'invoiceReferenceNumber',
      invoiceHelpDialog: false,
      invoiceNumber: "", //'017290424210 770',
      propertyRef: -1,
      propertyAddress: "",
      confirmProperty: false,
      showTermsDialog: false,
      terms: "",
      statementDeliveryTypes: [],
      statementDeliveryTypeId: 199,
      consentBillsViaEmail: true,
      consentMessagesViaEmail: true,
      consentMessagesViaSms: true,
      consentTerms: false,
      confirmationDialog: false,

      timerCount: 0,
      timeLimit: null,
      timerStarted: false,
      timerCountDisplay: "",
    };
  },
  computed: {
    completePhoneNumber: function () {
      let phone = this.dialCode + this.phoneNumber;
      return phone.replaceAll(/\D/g, "");
    },
    editableTabs: function () {
      if (this.phoneOtpCode != "" && this.sessionId != "") return true;
      else return false;
    },
    terms1: function () {
      return this.terms.replaceAll("<p>", "\n").replaceAll("</p>", "\n");
    },
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => this.timerCount--, 1000);
          this.timerCountDisplay =
            this.secsToMins(this.timerCount) +
            this.$t("EbillRegistration.sessionExpiry");
        } else if (this.timerStarted == true) {
          this.timerCountDisplay = this.$t("EbillRegistration.sessionExpired");
          this.cancelEbill();
          this.showMessage(this.$t("EbillRegistration.sessionExpired"), 2);
        } else this.timerCountDisplay = "";
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  created() {
    let sett = this.$store.getters.getSettings;
    if (sett != null && sett != undefined)
      this.timeLimit = sett.otpSessionStepSeconds;

    this.getLookups();
    this.getRefNumberResources();
  },
  methods: {
    getRefNumberResources() {
      this.getMessage();
      this.getImage();
    },
    getMessage() {
      axios
        .post("/Utility/GetMessage", { Lang: this.$i18n.locale, TextId: 110 })
        .then((response) => {
          if (response.data.data.status == 0)
            this.refNumberResources.description = response.data.settings.text;
        });
    },
    getImage() {
      axios.post("/Utility/GetPortalImage").then((response) => {
        if (response.data.data.status == 0)
          this.refNumberResources.image =
            response.data.settings.applicationsIcon;
      });
    },
    getLookups() {
      this.$root.$emit("enable_disable_loader", true);
      axios
        .get(
          "/ChangeCommunication/GetLookups?languageCode=" + this.getLanguage()
        )
        .then((response) => {
          if (response.status == 200) {
            this.terms = response.data.terms;
            this.statementDeliveryTypes = response.data.statementDeliveryTypes;
          } else
            this.errorHandling(this.$t("EbillRegistration.ErrorGettingOTP"), 1);
        })
        .catch((e) => {
          this.errorHandling(
            this.$t("EbillRegistration.ErrorGettingOTP") +
              ": " +
              e.response.data,
            1
          );
        })
        .finally(this.$root.$emit("enable_disable_loader", false));
    },
    onSelect({ name, iso2, dialCode }) {
      this.dialCode = dialCode;
    },
    leaveOnlyNumbers(num) {
      return num.replaceAll(/\D/g, "");
    },
    verifyPhoneNumberEmail() {
      this.phoneNumber = this.leaveOnlyNumbers(this.phoneNumber);

      if (this.completePhoneNumber.length < 11) {
        this.errorHandling(this.$t("EbillRegistration.PhoneNumberError"), 1, 1);
        return;
      } else if (
        this.dialCode == "357" &&
        this.phoneNumber.substring(0, 1) != "9"
      ) {
        this.errorHandling(this.$t("EbillRegistration.NoCyMobileNum"), 1, 1);
        return;
      }

      if (utils.validateEmail(this.email) == false) {
        this.errorHandling(this.$t("EbillRegistration.EmailError"), 1, 1);
        return;
      }

      this.$root.$emit("enable_disable_loader", true);
      axios
        .post("/Session/Create", {
          MobileNo: this.completePhoneNumber,
          Email: this.email,
          LanguageCode: this.getLanguage(),
        })
        .then((response) => {
          if (response.status == 200) {
            this.sessionId = response.data;
            this.activeTab = "otpVerificationPhone";
            this.successHandling(this.$t("EbillRegistration.OtpCodesSend"), 1);
            this.timerCount = this.timeLimit;
            this.timerStarted = true;
          } else
            this.errorHandling(this.$t("EbillRegistration.ErrorGettingOTP"), 1);
        })
        .catch((e) => {
          this.errorHandling(
            this.$t("EbillRegistration.ErrorGettingOTP") +
              ": " +
              e.response.data,
            1
          );
        })
        .finally(this.$root.$emit("enable_disable_loader", false));
    },
    validateOtpCode(type) {
      if (this.sessionId < 0) {
        this.errorHandling(
          this.$t("EbillRegistration.OtpValidationFailed"),
          type == "phone" ? 2 : 3
        );
        return;
      }

      this.$root.$emit("enable_disable_loader", true);
      let parameter = {
        SessionId: this.sessionId,
        OtpCode: type == "phone" ? this.phoneOtpCode : this.emailOtpCode,
        OtpCodeType: type == "phone" ? 2 : 1,
      };

      axios
        .post("/Session/ValidateOtp", parameter)
        .then((response) => {
          if (response.status == 200) {
            if (type == "phone" && response.data == true) {
              this.isPhoneOtpCodeValid = true;
              this.activeTab = "otpVerificationEmail";
              this.successHandling(this.$t("EbillRegistration.OtpVerified"), 2);
              return;
            } else if (type == "email" && response.data == true) {
              this.isEmailOtpCodeValid = true;
              this.activeTab = "invoiceReferenceNumber";
              this.successHandling(this.$t("EbillRegistration.OtpVerified"), 3);
              return;
            }
          }
          this.errorHandling(
            this.$t("EbillRegistration.OtpValidationFailed"),
            type == "phone" ? 2 : 3
          );
        })
        .catch((e) => {
          this.errorHandling(
            this.$t("EbillRegistration.OtpValidationFailed") +
              ": " +
              e.response.data,
            type == "phone" ? 2 : 3
          );
        })
        .finally(this.$root.$emit("enable_disable_loader", false));
    },
    submitInvoiceNumber() {
      this.invoiceNumber = this.leaveOnlyNumbers(this.invoiceNumber);

      if (
        this.invoiceNumber == "" ||
        this.invoiceNumber < 0 ||
        this.invoiceNumber.length < 15
      ) {
        this.errorHandling(this.$t("EbillRegistration.InvoiceNumberError"), 4);
        return;
      }

      this.propertyRef = "0" + this.invoiceNumber.substring(2, 7);

      this.$root.$emit("enable_disable_loader", true);

      let parameter = {
        propertyRef: this.propertyRef,
        //smsOtpCode: this.phoneOtpCode,
        sessionId: this.sessionId,
        otpCode: this.emailOtpCode,
        otpCodeType: 1, // Email
        validateEmail: false,
        languageCode: this.getLanguage(),
      };

      axios
        .post("/ChangeCommunication/GetPropertyAddress", parameter)
        .then((response) => {
          if (response.status == 200) {
            this.activeTab = "confirmProperty";
            this.successHandling(null, 4);
            this.propertyAddress = response.data;
            this.confirmationDialog = false;
          } else
            this.errorHandling(
              this.$t("EbillRegistration.WrongInvoiceNumber"),
              4
            );
        })
        .catch((e) => {
          this.errorHandling(e.response.data, 4);
        })
        .finally(this.$root.$emit("enable_disable_loader", false));
    },
    propertyConfirmed() {
      this.confirmPropertyTab = true;
      this.confirmPropertyTabError = "";
      this.activeTab = "subscriptionPreference";
    },
    submitPreferences() {
      this.submitButtonDisabled = true;

      this.$root.$emit("enable_disable_loader", true);
      let parameter = {
        propertyRef: this.propertyRef,
        smsOtpCode: this.phoneOtpCode,
        emailOtpCode: this.emailOtpCode,
        sessionId: this.sessionId,
        consentToReceiveSms: this.consentMessagesViaSms,
        consentToReceiveEmail: this.consentMessagesViaEmail,
        statementDeliveryTypeId: 199, //199 == email
        updateMobileNo: true,
        updateEmail: true,
      };

      axios
        .post("/ChangeCommunication/UpdateDetails", parameter)
        .then((response) => {
          if (response.status == 200) {
            this.successHandling(
              this.$t("EbillRegistration.PreferencesSubmitedSuccessfully"),
              5
            );
            this.activeTab = "preferencesSubmitedSuccessfully";
            this.timerCount = 0;
            this.timerStarted = false;
            this.confirmationDialog = false;
          }
        })
        .catch((e) => {
          this.errorHandling(e.response.data, 5);
        })
        .finally(this.$root.$emit("enable_disable_loader", false));
    },
    cancelEbill() {
      this.confirmationDialog = false;
      //this.$router.push('/login');
    },

    getLanguage() {
      let lang = this.$localStorage.get("_lang");
      return lang != null && lang != "" ? lang : "el";
    },
    secsToMins(time) {
      var minutes = Math.floor(time / 60);
      var seconds = time - minutes * 60;
      return minutes + "m " + seconds + "s ";
    },
    successHandling(msg, tab) {
      switch (tab) {
        case 1:
          this.registerPhoneTabError = null;
          this.registerPhoneTab = true;
          break;
        case 2:
          this.otpVerificationPhoneTabError = null;
          this.otpVerificationPhoneTab = true;
          break;
        case 3:
          this.otpVerificationEmailTabError = null;
          this.otpVerificationEmailTab = true;
          break;
        case 4:
          this.invoiceReferenceNumberTabError = null;
          this.invoiceReferenceNumberTab = true;
          break;
        case 5:
          this.subscriptionPreferenceTabError = null;
          this.subscriptionPreferenceTab = true;
          break;
      }
      if (msg != null) this.showMessage(msg, 3);
    },
    errorHandling(msg, tab, type = 2) {
      switch (tab) {
        case 1:
          this.registerPhoneTabError = msg;
          this.registerPhoneTab = false;
          break;
        case 2:
          this.otpVerificationPhoneTabError = msg;
          this.otpVerificationPhoneTab = false;
          break;
        case 3:
          this.otpVerificationEmailTabError = msg;
          this.otpVerificationEmailTab = false;
          break;
        case 4:
          this.invoiceReferenceNumberTabError = msg;
          this.invoiceReferenceNumberTab = false;
          break;
        case 5:
          this.subscriptionPreferenceTabError = msg;
          this.subscriptionPreferenceTab = false;
          break;
        default:
          return;
      }

      this.showMessage(msg, type);
    },
    showMessage(msg, type) {
      this.message = msg;
      if (type === 2)
        this.message += " " + this.$t("messages.ProblemPersistsContactSupport");
      this.$notify({
        duration: 10000,
        group: "app",
        text: msg,
        type:
          type == 1 ? "warn" : type == 2 ? "error" : type == 3 ? "success" : "",
      });
    },
  },
};
